import LazyLoad from "vanilla-lazyload";

const lazyLoadInstance = new LazyLoad({
  // eslint-disable-line no-unused-vars
  elements_selector: ".js-lazy",
  threshold: "500",
  class_loaded: "js-loaded",
});

if (window.innerWidth > 850) {
  // Only load product bg secondary images on big screens
  // because probability of having cursor in smaller screens is small.
  const lazyLoadInstanceBg = new LazyLoad({
    // eslint-disable-line no-unused-vars
    elements_selector: ".js-lazy-bg",
    class_loaded: "js-loaded",
  });
}

const lazyLoadInstanceBg = new LazyLoad({
  // eslint-disable-line no-unused-vars
  elements_selector: ".js-lazy-video",
  // For some reason, video doesn't start automatically with autoplay attr...
  callback_enter: (el) => {
    el.setAttribute("poster", el.getAttribute("data-poster"));
  },
  callback_loaded: (el) => {
    if (window.innerWidth > 850) {
      el.click(); // force click to make sure play() works.
      setTimeout(() => {
        // give some time to the browser to recognize the click and play()
        el.play();
      }, 250);
    } else {
      el.setAttribute("controls", "controls");
    }
  },
});
